<template>
  <div class="FoundGame_box">
    <div class="game_Progress_box"></div>
    <div class="FoundGame">
      <div class="Gameinfo">{{ $t("foundapp.info") }}</div>

      <div>
        <div class="TGA_BOX MG_B10">
          <div class="TGA_INPUT_BOX">
            <div class="TGA_TEXT">
              <span class="must">*</span>
              {{ $t("foundapp.appname") }}
            </div>
            <input
              type="text"
              class="TGA_INPUT TGA_PD"
              v-model="appName"
              @blur.prevent="changeCount()"
              @input="btnselect"
              :placeholder="$t('foundapp.appname')"
            />
          </div>
        </div>
      </div>

      <div class="TGA_BOX select_i8">
        <div
          class="TGA_INPUT_BOX"
          :class="selectData.length <= 0 ? 'TGAdd' : ''"
        >
          <div class="TGA_TEXT">
            <span class="must">*</span>
            {{ $t("foundapp.lang") }}
          </div>
          <a-select
            style="height: 40px; width: 367px"
            size="large"
            :filterOption="filterDeliverOption"
            default-value="EN"
            placeholder=""
            @change="handleChange"
          >
            <a-select-option
              v-for="(item, index) in adsss"
              :value="item.id.toString()"
              :key="item.id.toString()"
              >{{ item.ct }}</a-select-option
            >
          </a-select>
          <div class="init_box">
            <div class="init_text"></div>
            <div class="init_active" v-if="selectData.length <= 0">
              <img src="@/img/mistake.png" alt="" />
              <span>{{ $t("foundapp.langkong") }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="check_box">
        <div @click="selectcheck" class="check_box CU">
          <div class="nocheck" v-if="!check"></div>
          <img class="check" v-else src="@/img/check.png" alt="" />
        </div>

        <div class="checktext">
          {{ $t("foundapp.agreement") }}
          <span class="CU">{{ $t("foundapp.agreement1") }}</span>
        </div>
      </div>
      <!--  -->
      <div class="btn CU" :class="BTN ? '' : 'btn_active'" @click="establish">
        {{ $t("foundapp.createapp") }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      BTN: false,
      selectData: "EN",
      check: false,
      appName: "",
      adsss: [
        {
          ct: this.$t("foundapp.chinese"),
          id: "ZH",
        },
        {
          ct: this.$t("foundapp.english"),
          id: "EN",
        },
        {
          ct: this.$t("foundapp.Turkey"),
          id: "TR",
        },
      ],
    };
  },
  computed: {},
  methods: {
    ...mapActions("user", ["tipMessage"]),
    ...mapActions("game", ["CreateAppInfo"]),
    // 点击按钮创建游戏
    async establish() {
      if (!this.BTN) {
        return;
      }
      if (!this.check) {
        return;
      }

      var obj = {
        defaultLanguage: this.selectData,
        appName: this.appName,
      };

      var res = await this.CreateAppInfo({
        $axios: this.$axios,
        ...obj,
      });
      if (res.code == 200) {
        this.$router.push({
          path: "/appInfo?id=" + res.data.id + "&appId=" + res.data.appId,
        });
      }
    },

    changeCount() {
      this.btnselect();
    },
    btnselect() {
      if (this.check && this.appName != "") {
        this.BTN = true;
      } else {
        this.BTN = false;
      }
    },
    handleChange(value) {
      var self = this;
      this.selectData = value;
      this.btnselect();
    },
    filterDeliverOption(input, option) {
      console.log("input, option", input, option);
    },
    selectcheck() {
      this.check = !this.check;
      this.btnselect();
    },
  },
};
</script>

<style scoped="scoped">
.FoundGame {
  margin: 0 auto;
  padding: 72px 0 90px 0;
  width: 1160px;
  background-color: #ffffff;
  box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.Gameinfo {
  font-weight: bold;
  font-size: 22px;
  color: #282828;
  text-align: center;
  margin-bottom: 90px;
}

.game_Progress_box {
  width: 1060px;
  position: relative;
  margin: 50px auto;
  display: flex;
  justify-content: space-between;
}

.game_Progress {
  width: 860px;
  height: 2px;
  position: absolute;
  top: 5px;
  left: 100px;
  background-color: #dddddd;
}

.game_Progress_wid {
  width: 148px;
  height: 2px;
  background-color: #4990fa;
}

.game_Progress_centent {
  position: relative;
  z-index: 10;
  width: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.game_Progress_sum {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  font-size: 12px;
  color: #ffffff;
  text-align: center;
  line-height: 18px;
  background-color: #dddddd;
}

.game_Progress_sum_active .game_Progress_sum {
  background-color: #4990fa;
}

.game_Progress_sum_active .game_Progress_text {
  color: #666666;
}

.game_Progress_text {
  margin-top: 14px;
  font-size: 14px;
  color: #aaaaaa;
}

.radio_btn {
  height: 40px;
  width: 367px;
  display: flex;
  align-items: center;
}

.radio_chunk {
  display: flex;
  align-items: center;
  margin-right: 40px;
}

.radio_text {
  color: #282828;
  font-size: 14px;
  margin-left: 10px;
}

.FoundGame .TGA_TEXT {
  line-height: 40px;
}

.FoundGame .TGA_INPUT {
  width: 367px;
  height: 40px;
}

.FoundGame .TGA_INPUT_INIT {
  height: 40px;
}

.select_i8 {
  display: flex;
  justify-content: center;
}

.init_box {
  width: 300px;
  position: absolute;
  right: -310px;
  top: 0;
  display: flex;
  height: 40px;
  align-items: center;
}

.init_text {
  font-size: 12px;
  color: #8eb5fb;
}

.init_active {
  margin-left: 10px;
  height: 100%;
  display: flex;
  align-items: center;
}

.init_active span {
  margin-left: 7px;
  color: #f65651;
  font-size: 14px;
}

textarea {
  border: 1px solid #e5e5e5;
  border-radius: 4px;
}

textarea:focus {
  outline: none !important;
  border: 1px solid #40a9ff;
}

.check_box {
  display: flex;
  align-items: center;
  justify-content: center;
}

.nocheck {
  box-sizing: border-box;
  width: 14px;
  height: 14px;
  border-radius: 2px;
  border: solid 1px #282828;
}

.check {
  width: 14px;
  height: 14px;
}

.checktext {
  margin-left: 9px;
}

.checktext span {
  font-size: 14px;
  color: #4990fa;
}

.btn {
  margin: 30px auto 0;
  width: 367px;
  height: 50px;
  background-color: #4990fa;
  border-radius: 4px;
  text-align: center;
  line-height: 50px;
  color: #ffffff;
  font-size: 16px;
}

.btn_active {
  background-color: #dddddd;
}

/* .TGAa  .ant-select-selection{
    background-color: red;
  } */
.TGAdd .ant-select-selection.ant-select-selection--multiple {
  border: 1px solid red;
}

.TGA_BOX.MG_B10 {
  margin-bottom: 10px;
}

.button {
  margin-left: 5px;
}

.tip {
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/app/Foundapp.vue